"use client";

import {
  StackBreakpointProvider
} from "./chunk-RNYP3SNO.mjs";
import {
  StackThemeProvider
} from "./chunk-6WJTNVDW.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-EX6ADWAR.mjs";

// src/StackProvider.tsx
import { jsx } from "react/jsx-runtime";
function StackProvider({
  children,
  breakpoints,
  theme
}) {
  return /* @__PURE__ */ jsx(StackBreakpointProvider, __spreadProps(__spreadValues({ mobile: 0, desktop: 1024 }, breakpoints), { children: /* @__PURE__ */ jsx(StackThemeProvider, { theme, children }) }));
}

export {
  StackProvider
};
